'use client';

import React, { useState, createContext, PropsWithChildren } from 'react';

export const AudioContext = createContext({
  audioSource: '',
  // eslint-disable-next-line
  setAudioSource: (src: string) => {},
});

export const AudioProvider = ({ children }: PropsWithChildren) => {
  const [data, setData] = useState<{
    audioSource: string;
  }>({
    audioSource: '',
  });

  const setAudioSource = (src: string) => {
    setData({ audioSource: src });
  };

  const contextValue = {
    ...data,
    setAudioSource,
  };

  return <AudioContext.Provider value={contextValue}>{children}</AudioContext.Provider>;
};
